import '../assets/css/main.css';
import NavBar from "../components/navbar";
import Footer from "../components/footer";

function About() {
  return (
    <>
      <NavBar />
      <main className="main">
        <section id="about" className="about section">
          <div className="container section-title" data-aos="fade-up">
            <h2>About</h2>
            <p>
              A few words about me, my passion for music, and my many other interests!
            </p>
          </div>
          <div className="container" data-aos="fade-up" data-aos-delay={100}>
            <div className="row gy-4 justify-content-center">
              <div className="col-lg-4">
                <img
                    src="assets/img/profile-img.jpg"
                    className="img-fluid"
                    alt=""
                />
              </div>
              <div className="col-lg-8 content">
                <h2>Aspiring Musical Composer of Baroque-Inspired Works</h2>
                <br />
                <div className="row">
                  <div className="col-lg-6">
                    <ul>
                      <li>
                        <i className="bi bi-chevron-right"/>{" "}
                        <strong>Website:</strong> <span>www.bravaldi.com</span>
                      </li>
                      <li>
                        <i className="bi bi-chevron-right"/> <strong>City:</strong>{" "}
                        <span>Los Angeles Metro, CA, USA</span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6">
                    <ul>
                      <li>
                        <i className="bi bi-chevron-right"/>{" "}
                        <strong>Email:</strong> <span>jose_bravo@hotmail.com</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <p className="py-3">
                    Thank you for visiting my website! I fell in love with classical music from the Baroque period during my time in high school and continue to enjoy it regularly.
                    During my junior year in high school, I started to write classical music inspired by work of the Baroque period and have been writing music off and on since then.
                    In 2024, I committed to go over my works, ready them as needed, and publish them for others to enjoy. Putting together this website was a key part of being able to share
                    my musical works with you and I am humbled that you have stopped by to take a look.
                    <br />
                    <br />
                    In addition to Baroque music, I am also passionate about all things Sherlock Holmes, many works by Michael Crichton, and Anime. I also enjoy tinkering with flight
                    simulators, from desktop to room-sized setups, this hobby has also kept me busy.
                    <br />
                    <br />
                    I am a Los Angeles native and have lived here my whole life. I am joined here with my wife and two children that are the loves of my life and are my biggest cheerleaders
                    in encouraging me to continue in my musical passions.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default About;